import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA, 
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { DialogData } from '../purchaseorder-delete-modal/purchaseorder-delete-modal.component';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { StoresService } from 'src/app/home/services/stores.service';

@Component({
  selector: 'app-implants-edit',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    CommonModule
  ],
  templateUrl: './implants-edit.component.html',
  styleUrls: ['./implants-edit.component.scss', '../../app.component.scss']
})
export class ImplantsEditComponent implements OnInit{
  public dialogData: any;

  public implantDetails: any;

  constructor(
    public storeService: StoresService,
    public dialogRef: MatDialogRef<ImplantsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    this.getImplantDetails();
  }

  getImplantDetails(){
    this.storeService.getImplantDetails(this.dialogData.storeId, this.dialogData.implantId).subscribe((res)=>{
      if (res.data) {
        this.implantDetails = res.data;
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
